import { render, staticRenderFns } from "./com-component.vue?vue&type=template&id=07196f01"
import script from "./com-component.vue?vue&type=script&lang=js"
export * from "./com-component.vue?vue&type=script&lang=js"
import style0 from "./com-component.vue?vue&type=style&index=0&id=07196f01&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07196f01')) {
      api.createRecord('07196f01', component.options)
    } else {
      api.reload('07196f01', component.options)
    }
    module.hot.accept("./com-component.vue?vue&type=template&id=07196f01", function () {
      api.rerender('07196f01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/common/com-component.vue"
export default component.exports